import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Instructions.frontend.types'

@Injectable({ providedIn: 'root' })
export class Instructions_create_instruction_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { entityName: string, entityKey1: number, instruction: string, entityKey2?: number, entityKey3?: number, entityKey4?: number, typeId: number }): Promise<{ reasons?: string[], instruction_id?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityName)) {
      missingRequiredInParams.push('\'entityName\'');
    }
    if (isNil(inParams.entityKey1)) {
      missingRequiredInParams.push('\'entityKey1\'');
    }
    if (isNil(inParams.instruction)) {
      missingRequiredInParams.push('\'instruction\'');
    }
    if (isNil(inParams.typeId)) {
      missingRequiredInParams.push('\'typeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/functions/create_instruction_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

